import { useEffect } from 'react';
import { useEditorStore } from '../store/editorStore';

export const KeyboardShortcuts: React.FC = () => {
  const { incrementPreviewKey } = useEditorStore();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl/Cmd + S: 保存（触发预览更新）
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        incrementPreviewKey();
      }

      // Ctrl/Cmd + Enter: 运行代码
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault();
        incrementPreviewKey();
      }

      // Ctrl/Cmd + N: 新建文件
      if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
        e.preventDefault();
        const fileId = useEditorStore.getState().createFile('untitled.js', 'javascript');
        useEditorStore.getState().addTab(fileId);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null;
};
